// extracted by mini-css-extract-plugin
export default {"packs":"Packs_packs__I2mXC","featuresList":"Packs_featuresList__AQF8J","item":"Packs_item__JPTip"};